import { FC } from 'react';
import { Typography } from '@mui/material';

import { EItineraryTimeChange } from '@mopla/utils';

import { useBookingRide } from '../BookingRideContext';

import { RideDateLabel, TRideDateDisplay } from './RideDateLabel';
import { checkIsTimeChangeHighlighted } from './utils';

interface IRideTimingLabelProps {
	display?: TRideDateDisplay;
}

/**
 * The ride's own timing, with the delay affordances every screen shows the
 * same way: the time painted on a relevant change, prefixed with "~" while the
 * delay has no known length.
 */
export const RideTimingLabel: FC<IRideTimingLabelProps> = ({ display }) => {
	const { rideTiming, rideTimeChange } = useBookingRide();

	if (!rideTiming) return null;
	const isHighlighted = checkIsTimeChangeHighlighted(rideTimeChange.type);

	return (
		<RideDateLabel
			startDate={rideTiming.effectiveStartDateObj}
			endDate={rideTiming.effectiveEndDateObj}
			display={display}
			isApproximate={
				rideTimeChange.type === EItineraryTimeChange.INDETERMINATE_DELAY
			}
			render={(label) => (
				<Typography
					variant="l1"
					fontWeight={isHighlighted ? 700 : 400}
					color={isHighlighted ? 'warning.main' : 'primary'}
				>
					{label}
				</Typography>
			)}
		/>
	);
};
